import { useMetadata } from "@/hooks/useMetadata";
import { LegalDocument } from "../LegalDocument";
import { sections } from "./sections";

export default function TermsOfUsePage() {
  useMetadata({
    title: "Mohtawa Creative OS Terms of Service",
    description: "Detailed terms of service for Mohtawa Creative OS",
  });

  return (
    <LegalDocument
      title="Mohtawa Creative OS Terms of Service"
      sections={sections}
      intro={
        <p>
          Welcome to <a href="https://mohtawa.ai">Mohtawa Creative OS</a>! This
          platform is designed for content creators to share, promote, and
          distribute their work. Please read these Mohtawa Creative OS Terms of
          Service ("<span className="text-co-text">Terms</span>") carefully
          before using our website or services.
          <br />
          <br />
          By accessing or using our platform, and notably uploading your
          content,{" "}
          <span className="font-semibold text-co-text">
            you agree to be bound by these Terms
          </span>
          . If you do not agree with these Terms, do not use our platform.
        </p>
      }
    />
  );
}
